import { Locale } from '@libs/core';
import { CA_PROVINCES, US_STATES } from '@libs/common-next';

export const LOCAL_STORAGE = {
    SDD_ADDR: 'sddAddress',
};

export const localize = {
    [Locale['en-US']]: {
        stateProvinceSelection: US_STATES,
        stateProvinceLabel: 'State',
        stateProvinceValidation: 'State is required',
        zipPostalCode: 'Zip code',
        zipPostalCodeValidation: 'Zip code is required',
        zipPostalCodeValidationInvalid: 'Zip code is invalid',
        streetAddressValidation: 'Street address is required',
    },
    [Locale['en-CA']]: {
        stateProvinceSelection: CA_PROVINCES,
        stateProvinceLabel: 'Province',
        stateProvinceValidation: 'Province is required',
        zipPostalCode: 'Postal code',
        zipPostalCodeValidation: 'Postal code is required',
        zipPostalCodeValidationInvalid: 'Postal code is invalid',
        streetAddressValidation: 'Street address is required',
    },
};
